import React from "react";
import PropTypes from "prop-types";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import Colors from "../../../../themes/Colors";
import { Form, FormGroup } from "../../../../components/CustomForm/FormStyles";

const AdministracionUsuariosBusquedaForm = ({
  searchTerm,
  onStateChange,
  onSearch,
  isLoading,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <Form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginBottom: "30px",
        marginTop: "30px",
        alignItems: "center",
      }}
    >
      <FormGroup>
        <CustomInput
          placeholder="Buscar usuarios..."
          value={searchTerm}
          label="Buscar usuarios"
          isLabelWithContainer={true}
          labelWidth={"100%"}
          onChange={onStateChange("searchTerm")}
        />
      </FormGroup>

      <FormGroup>
        <CustomButton
          type="submit"
          label="Buscar"
          bgColor={Colors.primaryPrimera}
          hoverColor={Colors.darkGreenPrimera}
          textColor={Colors.white}
          hoverTextColor={Colors.white}
          loading={isLoading}
          width="150px"
          fontSize="16px"
        />
      </FormGroup>
    </Form>
  );
};

AdministracionUsuariosBusquedaForm.propTypes = {
  searchTerm: PropTypes.string,
  onStateChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

AdministracionUsuariosBusquedaForm.defaultProps = {
  searchTerm: "",
  isLoading: false,
};

export default AdministracionUsuariosBusquedaForm;
